import { defineStore } from 'pinia'

export const useTelemetryState = defineStore('telemetryState', {
  state: () => ({
    telemetryData: null,
    deviceId: null
  }),
  actions: {
    setTelemetryData (data) {
      this.telemetryData = data
    }

  }
})
